export default "__VITE_ASSET__Dqy76_dg__"